function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.71 40.25v3.6c0 1.18-1.03 2.15-2.3 2.15H6.31C5.02 46 4 45.03 4 43.84V10.78C4 9.6 5.03 8.63 6.3 8.63h6.91v26.59c0 2.77 2.42 5.03 5.38 5.03H34.7zm0-30.9V0H18.6c-1.27 0-2.3.97-2.3 2.16v33.06c0 1.19 1.03 2.16 2.3 2.16h26.1c1.28 0 2.31-.97 2.31-2.16V11.5h-9.98c-1.27 0-2.3-.97-2.3-2.16zm11.62-2.8L40 .64A2.39 2.39 0 0038.37 0h-.58v8.63H47v-.55c0-.57-.24-1.12-.67-1.52z"
})));